import { createSlice } from '@reduxjs/toolkit'

import initialState from './initialState'
import { reducers } from './reducers'
import {
  SLICE_NAME,
  createPlannedTrade,
  deletePlannedTrade,
  fetchPlannedTrades,
  fetchTradingPlanReports,
  updatePlannedTrade,
} from './thunks'

const tradingPlanSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder.addCase(fetchPlannedTrades.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchPlannedTrades.fulfilled, (state, action) => {
      const { data, meta } = action.payload
      state.loading = false
      state.plannedTrades = data
      state.pagination = {
        ...state.pagination,
        ...meta,
        order: state.pagination.order,
        orderBy: state.pagination.orderBy,
      }
    })
    builder.addCase(fetchPlannedTrades.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(fetchTradingPlanReports.pending, (state) => {
      state.reportsLoading = true
      state.reportsError = null
    })
    builder.addCase(fetchTradingPlanReports.fulfilled, (state, action) => {
      state.reportsLoading = false
      state.reports = action.payload
      state.reportsError = null
    })
    builder.addCase(fetchTradingPlanReports.rejected, (state, action) => {
      state.reportsLoading = false
      state.reports = null
      state.reportsError = action.error.message ?? 'Failed to load trading plan reports'
    })

    builder.addCase(createPlannedTrade.pending, (state) => {
      state.saving = true
    })
    builder.addCase(createPlannedTrade.fulfilled, (state) => {
      state.saving = false
    })
    builder.addCase(createPlannedTrade.rejected, (state) => {
      state.saving = false
    })

    builder.addCase(updatePlannedTrade.pending, (state) => {
      state.saving = true
    })
    builder.addCase(updatePlannedTrade.fulfilled, (state) => {
      state.saving = false
    })
    builder.addCase(updatePlannedTrade.rejected, (state) => {
      state.saving = false
    })

    builder.addCase(deletePlannedTrade.pending, (state) => {
      state.deleting = true
    })
    builder.addCase(deletePlannedTrade.fulfilled, (state) => {
      state.deleting = false
    })
    builder.addCase(deletePlannedTrade.rejected, (state) => {
      state.deleting = false
    })
  },
})

export const { updatePage, updatePageSize, updateOrderBy, updateSortOrder, resetReports } =
  tradingPlanSlice.actions

export const tradingPlanReducer = tradingPlanSlice.reducer
